import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router";
import "./App.css";
import Breadcrumb from "./components/Breadcrumb";
import ErrorBoundary from "./components/ErrorBoundary";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import CareerHighlightsPage from "./pages/CareerHighlightsPage";
import GalleryCategoryPage from "./pages/GalleryCategoryPage";
import GalleryPage from "./pages/GalleryPage";
import HomePage from "./pages/HomePage";
import QualificationsExperiencePage from "./pages/QualificationsExperiencePage";
import ResearchPage from "./pages/ResearchPage";

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

function App() {
    return (
        <ErrorBoundary>
            <div className="min-h-screen bg-secondary-50">
                <ScrollToTop />
                {/* Skip to main content link for keyboard users */}
                <a 
                    href="#main-content" 
                    className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 
                              bg-primary-500 text-white px-4 py-2 rounded-md z-50 
                              focus:outline-none focus:ring-2 focus:ring-primary-300"
                >
                    Skip to main content
                </a>
                
                <Navbar />
                
                {/* Add top padding to account for fixed navbar */}
                <div className="pt-16">
                    <Breadcrumb />
                    <main id="main-content" role="main" aria-label="Main content">
                        <ErrorBoundary>
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/research" element={<ResearchPage />} />
                                <Route path="/career-highlights" element={<CareerHighlightsPage />} />
                                <Route path="/qualifications-experience" element={<QualificationsExperiencePage />} />
                                <Route path="/gallery" element={<GalleryPage />} />
                                <Route path="/gallery/:categoryId" element={<GalleryCategoryPage />} />
                            </Routes>
                        </ErrorBoundary>
                    </main>
                    <Footer />
                </div>
            </div>
        </ErrorBoundary>
    );
}

export default App;


